import React from 'react';

import List from '../../../shared/components/List';
import Paragraph from '../../../shared/components/Paragraph';

const replaceLi = (content) => {
  let output;
  const regexLi = /<(li)[^>]*>(.*?)<\/\1>|<.*?\/>/gim;
  const splitUl = content.split(regexLi);

  if (splitUl && splitUl.length > 1) {
    for (let i = 2; i < splitUl.length; i += 3) {
      splitUl[i] = <li key={`poll_ul_${i}`}>{splitUl[i]}</li>;
    }

    output = splitUl.filter((el) => el !== 'li');
  } else {
    output = content;
  }

  return output;
};

const replaceStrongUl = (content) => {
  let output;
  const regex = /<(strong|ul)[^>]*>(.*?)<\/\1>|<.*?\/>/gim;
  const splitedString = content.split(regex);

  if (splitedString && splitedString.length > 1) {
    for (let i = 2; i < splitedString.length; i += 3) {
      const tag = splitedString[i - 1];
      if (tag === 'strong') {
        splitedString[i] = <strong key={`strong_${i}`}>{splitedString[i]}</strong>;
      } else if (tag === 'ul') {
        const splitUl = replaceLi(splitedString[i]);
        splitedString[i] = <List key={`list_${i}`}>{splitUl}</List>;
      }
    }

    output = (
      <>
        {splitedString.filter((el) => el !== 'strong' && el !== 'ul')}
      </>
    );
  } else {
    output = content;
  }

  return output;
};

const replaceHtml = (content) => {
  let output;
  const regexBr = /<(br)[^>]*>/gim;
  const splitBr = content.split(regexBr);
  if (splitBr && splitBr.length > 1) {
    for (let i = 0; i < splitBr.length; i += 2) {
      const splitBrReplaceStrongUl = replaceStrongUl(splitBr[i]);
      splitBr[i] = <Paragraph key={`split_paragraph_${i}`}>{splitBrReplaceStrongUl}</Paragraph>;
    }

    output = splitBr.filter((el) => el !== 'br');
  } else {
    const contentReplaceStrongUl = replaceStrongUl(content);
    output = (
      <Paragraph>
        {contentReplaceStrongUl}
      </Paragraph>
    );
  }

  return output;
};

export default replaceHtml;
